import { Component, OnInit } from '@angular/core';
import { ApilistService } from 'src/app/services/apilist.service';
import { CommonService } from 'src/app/services/common.service';
import { GlobalService } from 'src/app/services/global.service';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-add-degree',
  standalone: true,
  imports: [
    CommonModule, // ✅ for *ngIf, *ngFor, ngStyle
    FormsModule, // ✅ for [(ngModel)]
    ReactiveFormsModule, // ✅ for reactive forms
  ],
  templateUrl: './add-degree.component.html',
  styleUrls: ['./add-degree.component.scss'],
})
export class AddDegreeComponent implements OnInit {
  display: any = 'none';
  displayDelete: any = 'none';
  degree: any;
  degreeData: any;

  showAdd = false;
  showEdit = false;
  id: any;

  degreeForm: UntypedFormGroup;

  degreeType: any;

  showErr = false;

  searchval: any;

  error_messages = {
    degreeName: [{ type: 'required', message: 'Please enter degree' }],
    degreetypeVal: [{ type: 'required', message: 'Please select degree type' }],
  };
  deleteErr: any;
  degreeTypeData: any;
  adminName: any;
  adminImage: any;
  allDegree: any;
  allData: any;

  showData = false;
  showNodata = false;

  constructor(
    public utils: ApilistService,
    public commonservice: CommonService,
    public globalService: GlobalService,
    public formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService
  ) {
    this.degreeForm = this.formBuilder.group({
      degreeName: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      degreetypeVal: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });

    let admin = JSON.parse(localStorage.getItem('adminDetails'));
    let adminData = JSON.parse(admin);

    this.adminName = adminData[0].name;
    this.adminImage = adminData[0].image;

    if (this.adminImage == null || this.adminImage == undefined) {
      this.adminImage = 'assets/tenant-avatar.jpg';
    }
  }

  ngOnInit(): void {
    this.spinner.show();
    this.degreeForm.reset();
    const servicePath = this.utils.getApiConfigs('degree');
    this.commonservice
      .invokeService(servicePath[1].method, servicePath[1].path, '')
      .then((resp: any) => {
        // console.log("Degree", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.degreeData = resp.data;

          if (this.degreeData == '') {
            this.showNodata = true;
            this.showData = false;
          } else {
            this.showData = true;
            this.showNodata = false;
          }
        }
        this.allDegree = this.degreeData;
      });

    // GET DEGREE TYPE \\
    const servicePathDegree = this.utils.getApiConfigs('degreetype');
    this.commonservice
      .invokeService(servicePathDegree[1].method, servicePathDegree[1].path, '')
      .then((resp: any) => {
        if (resp.status_code == '200') {
          this.degreeTypeData = resp.data;
        }
      });
  }

  onChangeEvent(event) {
    // console.log("event", event);

    var val = event.target.value;
    // console.log("val", val);

    this.allData = this.degreeData;

    // console.log("All Data", this.allData);

    if (val) {
      this.allDegree = this.allData.filter((item) =>
        item.degree.toLowerCase().includes(val.toLowerCase())
      );
    }

    // console.log("Courses Data", this.allDegree);
    if (this.allDegree == '') {
      this.globalService.showError('No data found');
    }
  }

  reset() {
    this.ngOnInit();
    this.searchval = '';
  }

  openAdd() {
    this.degreeForm.reset();
    this.display = 'block';
    this.showAdd = true;
    this.showEdit = false;
  }

  editDegree(data) {
    // console.log("Data", data);
    this.display = 'block';
    this.showAdd = false;
    this.showEdit = true;

    this.degree = data.degree;
    this.id = data.id;
    this.degreeType = data.type_id;
    // console.log("Degree type", this.degreeType);
  }

  deleteDegree(data) {
    this.displayDelete = 'block';
    this.deleteErr = '';
    this.id = data.id;
  }

  onCloseHandled() {
    this.display = 'none';
    this.displayDelete = 'none';
    this.ngOnInit();
  }

  addDegree() {
    this.spinner.show();
    let payload = {
      degree: this.degree,
      type_id: this.degreeType,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('degree');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        // console.log("resp", resp);
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Degree added successfully');
          this.display = 'none';
          this.ngOnInit();
          this.degreeForm.reset();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.data);
          this.globalService.showError(resp.data);
        }
      });
  }

  updateDegree() {
    this.spinner.show();
    let payload = {
      degree: this.degree,
      type_id: this.degreeType,
      id: this.id,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('degree');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Degree updated successfully');
          this.display = 'none';
          this.ngOnInit();
          this.degreeForm.reset();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.data);
          this.globalService.showError(resp.data);
          this.display = 'none';
        }
      });
  }

  delete() {
    this.spinner.show();
    let payload = {
      id: this.id,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('deletedegree');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        // console.log("resp", resp);
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Degree deleted successfully');
          this.displayDelete = 'none';
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.data);
          this.showErr = true;
          this.deleteErr = resp.message;
        }
      });
  }
}
